import { Expose, Type } from 'class-transformer';
import { PaginatedEntity } from '@core/entities';

export class UserContentSurveyList extends PaginatedEntity {
  @Type(() => UserContentSurveyEntity)
  survey: UserContentSurveyEntity[];
}

export class UserContentSurveyEntity {
  id: number;
  title: string;
  description: string;

  @Expose({ name: 'surveyType' })
  type: string;

  @Expose({ name: 'surveyStartDate' })
  @Type(() => Date)
  startDate: string;

  @Expose({ name: 'surveyEndDate' })
  @Type(() => Date)
  endDate: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  date: string;
}
